<template>
	<!-- 搜索查询页面 -->
	<div class="selectQuery">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">搜索查询</p>
					<div class="header_qk" @click.stop="closeBtn">清空</div>
				</div>
			</div>
		</van-sticky>
		<!-- 查询列表 -->
		<div class="bigList">
			<!-- fwValueLists -->
			<div class="fwBox" v-for="(itemselect,index) in fwValueLists">
				<p class="ifQueryTitle">{{itemselect.title}}</p>
				<div class="selectTxtBox">
					<div class="queryBox" :class="ys2 ? { yangshi1: ys1 ,yangshi2: ys2} : ''">
            <van-checkbox v-for="(item,index) in itemselect.retrievalValueList" name="item.label"
                          checked-color="#ff4081" v-model="item.selected" @click="isradiofwValuecheck(item.value)">
              <span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
            </van-checkbox>
					</div>
					<div class="seleImg" @click="toggle01('fwValue',itemselect,itemselect.id )">
						<img src="../../assets/img/arr.png" alt="">
					</div>
				</div>
			</div>
			<!-- sexValueLists -->
      <div class="fwBox" v-for="(itemselect,index) in sexValueLists">
        <p class="ifQueryTitle">{{itemselect.title}}</p>
        <div class="selectTxtBox">
          <div class="queryBox" :class="ys3  ? { yangshi1: ys1 ,yangshi2: ys3} : ''">
            <van-checkbox v-for="(item,index) in itemselect.retrievalValueList" name="item.label"
                          checked-color="#ff4081" v-model="item.selected" @click="isradiosexValuecheck(item.value)">
              <span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
            </van-checkbox>
          </div>
          <div class="seleImg" @click="toggle02('sexValue',itemselect,itemselect.id )">
            <img src="../../assets/img/arr.png" alt="">
          </div>
        </div>
      </div>

			<!-- ycValueLists -->
			<div class="fwBox" v-for="(itemselect,index) in ycValueLists">
				<p class="ifQueryTitle">{{itemselect.title}}</p>
				<div class="selectTxtBox">
					<div class="queryBox" :class="ys4  ? { yangshi1: ys1 ,yangshi2: ys4} : ''">
            <van-checkbox v-for="(item,index) in itemselect.retrievalValueList" name="item.label"
                          checked-color="#ff4081" v-model="item.selected" @click="isradioycValuecheck(item.value)">
              <span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
            </van-checkbox>
					</div>
					<div class="seleImg" @click="toggle03('ycValue',itemselect,itemselect.id )">
						<img src="../../assets/img/arr.png" alt="">
					</div>
				</div>
			</div>
			<!-- sjValueLists -->
			<div class="fwBox" v-for="(itemselect,index) in sjValueLists">
				<p class="ifQueryTitle">{{itemselect.title}}</p>
				<div class="selectTxtBox">
					<div class="queryBox" :class="ys5  ? { yangshi1: ys1 ,yangshi2: ys5} : ''">

            <van-checkbox v-for="(item,index) in itemselect.retrievalValueList" name="item.label"
                          checked-color="#ff4081" v-model="item.selected" @click="isradiosjValuecheck(item.value)">
              <span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
            </van-checkbox>
					</div>
					<div class="seleImg" @click="toggle04('sjValue',itemselect,itemselect.id )">
						<img src="../../assets/img/arr.png" alt="">
					</div>
				</div>
			</div>
			<!-- sdValueLists -->
			<div class="fwBox" v-for="(itemselect,index) in sdValueLists">
				<p class="ifQueryTitle">{{itemselect.title}}</p>
				<div class="selectTxtBox">
					<div class="queryBox" :class="ys6  ? { yangshi1: ys1 ,yangshi2: ys6} : ''">

            <van-checkbox v-for="(item,index) in itemselect.retrievalValueList" name="item.label"
                          checked-color="#ff4081" v-model="item.selected" @click="isradiosdValuecheck(item.value)">
              <span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
            </van-checkbox>
					</div>
					<div class="seleImg" @click="toggle05('sdValue',itemselect,itemselect.id )">
						<img src="../../assets/img/arr.png" alt="">
					</div>
				</div>
			</div>
			<!-- typeValueLists -->
			<div class="fwBox" v-for="(itemselect,index) in typeValueLists">
				<p class="ifQueryTitle">{{itemselect.title}}</p>
				<div class="selectTxtBox">
					<div class="queryBox" :class="ys7  ? { yangshi1: ys1 ,yangshi2: ys7} : ''">

            <van-checkbox v-for="(item,index) in itemselect.retrievalValueList" name="item.label"
                          checked-color="#ff4081" v-model="item.selected" @click="isradiotypeValuecheck(item.value)">
              <span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
            </van-checkbox>
					</div>
					<div class="seleImg" @click="toggle06('typeValue',itemselect,itemselect.id )">
						<img src="../../assets/img/arr.png" alt="">
					</div>
				</div>
			</div>
			<!-- styleValueLists -->
			<div class="fwBox" v-for="(itemselect,index) in styleValueLists">
				<p class="ifQueryTitle">{{itemselect.title}}</p>
				<div class="selectTxtBox">
					<div class="queryBox" :class="ys8 ? { yangshi1: ys1 ,yangshi2: ys8} : ''">
            <van-checkbox v-for="(item,index) in itemselect.retrievalValueList" name="item.label"
                          checked-color="#ff4081" v-model="item.selected" @click="isradiostyleValuecheck(item.value)">
              <span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
            </van-checkbox>
					</div>
					<div class="seleImg" @click="toggle07('styleValue',itemselect,itemselect.id )">
						<img src="../../assets/img/arr.png" alt="">
					</div>
				</div>
			</div>

			<!-- labelValueLists -->
			<div class="fwBox" v-for="(itemselect,index) in labelValueLists">
				<p class="ifQueryTitle">{{itemselect.title}}</p>
				<div class="selectTxtBox">
					<div class="queryBox" :class="ys9 ? { yangshi1: ys1 ,yangshi2: ys9} : ''">
						<van-checkbox v-for="(item,index) in itemselect.retrievalValueList" v-if="itemselect.id == 7 ? true : false" name="item.label"
						 checked-color="#ff4081" v-model="item.selected" @click="ischeck(itemselect,item)">
							<span :class="item.selected == true ? 'active' : ''">{{item.label}}</span>
						</van-checkbox>
					</div>
					<div class="seleImg" @click="toggle08('labelValue',itemselect,itemselect.id )">
						<img src="../../assets/img/arr.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="foot_box">
			<div class="position_footer">
				<van-search v-model="value" v-model.trim="searchCondition" show-action placeholder="请输入搜索关键词" @search="onSearch()">
					<template #action>
						<div @click="onSearch()">搜索</div>
					</template>
				</van-search>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		data() {
			return {
				radio: false,
				seleHeight: '',
				HistoryList: [],
				ys1: true,
				ys2: false,
				ys3: false,
				ys4: false,
				ys5: false,
				ys6: false,
				ys7: false,
				ys8: false,
				ys9: false,
				selectBoxLists: [],
				value: '',
				btnactiveIndex: 0, //点击当前btn
				itemID: '', //每一条id
				historyList: [],
				searchCondition: '',
				checkboxList: [], //选中数据
				noBtnState: true,
				searchQueryRadioList: [],

				fwValueLists: [],
				sexValueLists: [],
				ycValueLists: [],
				sjValueLists: [],
				sdValueLists: [],
				typeValueLists: [],
				styleValueLists: [],
				labelValueLists:[],

				fwValue: [],
				sexValue: [],
				ycValue: [],
				sjValue: [],
				sdValue: [],
				typeValue: [],
				styleValue: [],

			}
		},
		created() {
			this.get_retrieve_page()
      const speech = new Speech()
      speech.init().then((data) => {
        // The "data" object contains the list of available voices and the voice synthesis params
        console.log("Speech is ready, voices are available", data)
      }).catch(e => {
        console.error("An error occured while initializing : ", e)
      })
		},
		methods: {
			noBtn(a, b) {
				console.log(a, b)
				this.noBtnState = !this.noBtnState;
			},
			closeBtn() {
				console.log(this.searchQueryRadioList,'searchQueryRadioList')
				this.labelValueLists.forEach(item => {
					item.retrievalValueList.forEach(item => {
						item.selected = false
					})
				})
				console.log(this.checkboxList, 'checkboxList')
				// window.location.reload();
				this.get_retrieve_page();//重新渲染
			},
			showToggle1(item, ind) {
				this.seleHeight = ind;
				//当点击第一次时，ys1从true变为false,Style样式yangshi1就会隐藏
				//再点击第二次的时候由false,变为true,显示样式
				this.ys1 = !this.ys1;
				//代码运行到下面，值为false的时候，取反，就会为true，Style样式yangshi2就会显示
				//这里到第二次点击的时候，就由true变为false，隐藏样式
				this.ys2 = !this.ys2; //这里 “  ！” 是取反
			},
			toggle01(a,item, ind){
				if(a == 'fwValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys2 = !this.ys2;
				};
			},
			toggle02(a,item, ind){
				if(a == 'sexValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys3 = !this.ys3;
				};
			},
			toggle03(a,item, ind){
				if(a == 'ycValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys4 = !this.ys4;
				};
			},
			toggle04(a,item, ind){
				if(a == 'sjValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys5 = !this.ys5;
				};
			},
			toggle05(a,item, ind){
				if(a == 'sdValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys6 = !this.ys6;
				};
			},
			toggle06(a,item, ind){
				if(a == 'typeValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys7 = !this.ys7;
				};
			},
			toggle07(a,item, ind){
				if(a == 'styleValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys8 = !this.ys8;
				};
			},
			toggle08(a,item, ind){
				if(a == 'labelValue'){
					this.seleHeight = ind;
					this.ys1 = !this.ys1;
					this.ys9 = !this.ys9;
				};
			},

			//复选框
			ischeck(item, itemInfo) {
				console.log(item, itemInfo, '222');
				if(itemInfo.label !='不限'){
					item.retrievalValueList[0].selected = false;
				}else if(itemInfo.label =='不限'){
					item.retrievalValueList.forEach(i =>{
						if(i.label == '不限'){
							i.selected = true;
						}else{
							i.selected = false;
						}
					})
				}
			},
			// 性向
			isradiosexValuecheck(id) {
				console.log(id, '性向')
				// let str = id;
				// let strs = new Array();
				// strs = str.split(",");
				this.sexValue = [];
        this.sexValue.push(id)
				// let obj = {};
				// obj[strs[1]] = strs[0];
				// this.sexValue.push(obj);
				// console.log(this.sexValue, 'sexValue')
				// // this.searchQueryRadioList.push(this.sexValue[0]);
				// if(this.sexValue[0].sexValue != 'a'){
					this.sexValueLists.forEach(item => {
						item.retrievalValueList.forEach(itmRetrival =>{
              itmRetrival.selected = false

							if(itmRetrival.value == id){
								itmRetrival.selected = true
							}
						})
					})
				// }
			},
			// 范围
			isradiofwValuecheck(id) {
				// console.log(id, '范围')
				// let str = id;
				// let strs = new Array();
				// strs = str.split(",");
				this.fwValue = [];
        this.fwValue.push(id)
				// let obj = {};
				// obj[strs[1]] = strs[0];
				// this.fwValue.push(obj);
				// console.log(this.fwValue, 'fwValue');
				// this.searchQueryRadioList.push(this.fwValue[0]);
				// if(this.fwValue[0].fwValue != 'a'){
					this.fwValueLists.forEach(item => {
						item.retrievalValueList.forEach(itmRetrival =>{
              itmRetrival.selected = false
							if(itmRetrival.value == id){
								itmRetrival.selected = true
							}
						})
					})
				// }
			},
			// 原创
			isradioycValuecheck(id) {
				// console.log(id, '原创')
				// let str = id;
				// let strs = new Array();
				// strs = str.split(",");
				// this.ycValue = [];
				// let obj = {};
				// obj[strs[1]] = strs[0];
				// this.ycValue.push(obj);
        this.ycValue = [];
        this.ycValue.push(id)
				// this.searchQueryRadioList.push(this.ycValue[0])
				// if(this.ycValue[0].ycValue != 'a'){
					this.ycValueLists.forEach(item => {
						item.retrievalValueList.forEach(itmRetrival =>{
              itmRetrival.selected = false
              if(itmRetrival.value == id){
                itmRetrival.selected = true

							}
						})
					})
				// }
			},
			isradiosjValuecheck(id) {
				// let str = id;
				// let strs = new Array();
				// strs = str.split(",");
				this.sjValue = [];
        this.sjValue.push(id)
				// let obj = {};
				// obj[strs[1]] = strs[0];
				// this.sjValue.push(obj);
				// if(this.sjValue[0].sjValue != 'a'){
					this.sjValueLists.forEach(item => {
						item.retrievalValueList.forEach(itmRetrival =>{
              itmRetrival.selected = false
							if(itmRetrival.value == id){
								itmRetrival.selected = true
							}
						})
					})
				// }
			},
			isradiosdValuecheck(id) {
				// let str = id;
				// let strs = new Array();
				// strs = str.split(",");
				this.sdValue = [];
        this.sdValue.push(id)
        // // let obj = {};
				// let obj = {};
				// obj[strs[1]] = strs[0];
				// this.sdValue.push(obj);
				// if(this.sdValue[0].sdValue != 'a'){
					this.sdValueLists.forEach(item => {
						item.retrievalValueList.forEach(itmRetrival =>{
              itmRetrival.selected = false

							if(itmRetrival.value == id){
								itmRetrival.selected = true
							}
						})
					})
				// }
			},
			isradiotypeValuecheck(id) {
				// let str = id;
				// let strs = new Array();
				// strs = str.split(",");
				this.typeValue = [];
        this.typeValue.push(id)
        //
				// let obj = {};
				// obj[strs[1]] = strs[0];
				// this.typeValue.push(obj);
				// if(this.typeValue[0].typeValue != 'a'){
					this.typeValueLists.forEach(item => {
						item.retrievalValueList.forEach(itmRetrival =>{
              itmRetrival.selected = false

							if(itmRetrival.value == id){
								itmRetrival.selected = true
							}
						})
					})
				// }
			},
			isradiostyleValuecheck(id) {
				// let str = id;
				// let strs = new Array();
				// strs = str.split(",");
				this.styleValue = [];
        this.styleValue.push(id)
        // let obj = {};
				// let obj = {};
				// obj[strs[1]] = strs[0];
				// this.styleValue.push(obj);
				// if(this.styleValue[0].styleValue != 'a'){
					this.styleValueLists.forEach(item => {
						item.retrievalValueList.forEach(itmRetrival =>{
              itmRetrival.selected = false

							if(itmRetrival.value == id){
								itmRetrival.selected = true
							}
						})
					})
				// }
			},
			onSearch() {
				this.checkboxList = [];
				if (this.labelValueLists.length != 0) {
					this.labelValueLists.forEach(item1 => {
						item1.retrievalValueList.forEach(item2 => {
							if (item2.selected == true  && item2.value != 'a') {
								var labelName = {};
								labelName[item1.name] = item2.value;
								this.checkboxList.push(labelName)
							}
						})
					})
				}

				console.log(this.fwValue[0], this.sexValue[0])

				this.$router.push({
					path: '/searchResult',
					query: {
						searchVal: this.searchCondition, //关键字Z
						fwValue: this.fwValue[0] || '',
						sexValue: this.sexValue[0] || '',
						ycValue: this.ycValue[0] || '',
						sjValue: this.sjValue[0] || '',
						sdValue: this.sdValue[0] || '',
						typeValue: this.typeValue[0] || '',
						styleValue: this.styleValue[0] || '',
						checkboxList: this.checkboxList || '',
						url: 'searchResult',
					}
				})
				//接口调用成功时把关键词储存起来
				// this.setLocalStorage();
				// console.log(this.historyList)
			},
			//储存历史搜索到LocalStorage
			setLocalStorage() {
				let searchWord = localStorage.getItem("searchWord");
				if (searchWord == null) {
					localStorage.setItem("searchWord", this.searchCondition);
				} else {
					let arr = localStorage.getItem("searchWord");
					arr = arr.split(",");
					//去除重复的历史搜索
					if (arr.indexOf(this.searchCondition) != -1) {
						arr = arr;
					} else {
						// unshift() 方法可向数组的开头添加一个或更多元素，并返回新的长度。
						arr.unshift(this.searchCondition);
					}
					this.historyList = arr;
					//设置历史搜索最多显示多少条
					if (this.historyList.length > 10) {
						// pop() 方法用于删除并返回数组的最后一个元素。
						this.historyList.pop();
					}
					localStorage.setItem("searchWord", this.historyList);
				}
			},
			back() {
				this.$router.go(-1);
			},
			get_retrieve_page() {
				this.$axios.post(this.$api.retrieve_page).then(res => {
					console.log(res.data.data)
					this.fwValueLists = [{
						title: '范围',
						id: 0,
						name: 'fwValue',
						isShowBox: false,
						retrievalValueList: res.data.data.fwValue
					}];
					this.sexValueLists = [{
						title: '性向',
						id: 1,
						name: 'sexValue',
						isShowBox: false,
						retrievalValueList: res.data.data.sexValue
					}];
					this.ycValueLists = [{
						title: '原创性',
						id: 2,
						name: 'ycValue',
						isShowBox: true,
						retrievalValueList: res.data.data.ycValue
					}];
					this.sjValueLists= [
						{
							title: '视角',
							id: 3,
							name: 'sjValue',
							isShowBox: true,
							retrievalValueList: res.data.data.sjValue
						}
					];
					this.sdValueLists=[
						{
							title: '时代 ',
							id: 4,
							name: 'sdValue',
							isShowBox: true,
							retrievalValueList: res.data.data.sdValue
						}
					];
					this.typeValueLists=[
						{
							title: '类型 ',
							id: 5,
							name: 'typeValue',
							isShowBox: true,
							retrievalValueList: res.data.data.typeValue
						}
					];
					this.styleValueLists= [
						{
							title: '风格',
							id: 6,
							name: 'styleValue',
							isShowBox: true,
							retrievalValueList: res.data.data.styleValue
						}
					];

					this.labelValueLists=[
						{
							title: '标签',
							id: 7,
							name: 'labelValue',
							isShowBox: true,
							retrievalValueList: res.data.data.labelValue
						}
					];

					var radioActiveVal = function(fnName){
						fnName.forEach((item1, index) => {
							console.log(index, 'index')
							if (index != 7) {
								item1.retrievalValueList.unshift({
									label: "不限",
									value: 'a',
									selected: true,
									id: 'a',
								})
							}
						})
					}
					radioActiveVal(this.fwValueLists);
					radioActiveVal(this.sexValueLists);
					radioActiveVal(this.ycValueLists);
					radioActiveVal(this.sjValueLists);
					radioActiveVal(this.sdValueLists);
					radioActiveVal(this.typeValueLists);
					radioActiveVal(this.styleValueLists);
					radioActiveVal(this.labelValueLists);
				})
			}
		}

	}
</script>
<style scoped lang="less">
	.van-search {
		padding: 0;
	}

	.van-search__action {
		color: #ff4081;
	}

	.van-field__control::placeholder {
		font-size: 16px;
		/*px*/
	}
	.white{
		color: #fff;
	}
	.black{
		color: #000;
	}

	.selectQuery {
		background-color: #fff;
		height: 100vh;
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			// background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}

				.header_qk {
					font-size: 30px;
					/*px*/
				}
			}

		}

		//查询列表
		.bigList {
			padding-bottom: 150px;
		}

		.fwBox {
			padding: 0 16px;
			border-bottom: 8px solid #f0f0f0;
			/*no*/
			background-color: #fff;

			.ifQueryTitle {
				font-size: 32px;
				/*px*/
				font-weight: 600;
				padding: 30px 0;
			}

			.selectTxtBox {
				display: flex;
				margin: 0 auto;

				button {
					// width: 114px;
					height: 55px;
					padding: 5px 24px;
					min-width: 114px;
					text-align: center;
					border: 0;
					margin-right: 16px;
					font-size: 28px;
					/*px*/
					display: inline-block;
					background-color: #fff;
					border: 1px solid #a8a8a8;
					/*no*/
					color: #4f4f4f;
					border-radius: 38px;
					margin-bottom: 20px;
				}

				.active_query {
					border-color: #ff4081;
					background-color: #ff4081;
					color: #fff;
				}

				.queryBox {
					flex: 1;
					height: 70px;
					overflow: hidden;

					.van-radio-group {
						/deep/.van-radio[aria-checked="true"] .van-radio__label {
							color: #fff!important;
						}
						/deep/.van-radio {
							position: relative;
							float: left;
							margin-right: 20px;
							margin-bottom: 20px;
							border: 0px solid #f5f5f5;
							/*no*/
							color: #4f4f4f;
							background-color: #f5f5f5;
							border-radius: 38px;
							/deep/.van-radio__label {
								margin: 0;
								line-height: 0;
								position: absolute;
								left: 0;
								width: calc((100vw - 32px) / 4);
								color: #000;
								line-height: 60px;
								background-color: transparent;
								text-align: center;

								span {
									color: #000;
								}

								span.active {
									color: #fff;
								}
							}

							/deep/.van-radio__icon.van-radio__icon--round {
								height: 60px;
								line-height: 60px;
								border-radius: 60px;

								.van-icon {
									width: calc((100vw - 32px) / 4);
									text-align: center;
									height: 60px;
									line-height: 60px;
									color: #4f4f4f;
									border-radius: 60px;
									border: 1px solid #f5f5f5;/*no*/
								}

								.van-icon::before {
									display: none;

								}
							}
						}
						/deep/.van-radio.bx_color{
							.van-radio__label{
								color: #fff;
								background-color: #ff4081;
							}
						}
					}


					.van-checkbox {
						position: relative;
						float: left;
						margin-right: 20px;
						margin-bottom: 20px;

						/deep/.van-checkbox__label {
							margin: 0;
							line-height: 0;
							position: absolute;
							left: 0;
							width: calc((100vw - 32px) / 4);
							color: #000;
							line-height: 60px;
							background-color: transparent;
							text-align: center;

							span {
								color: #000;
							}

							span.active {
								color: #fff;
							}
						}

						/deep/.van-checkbox__icon {
							height: 60px;
							line-height: 60px;

							.van-icon {
								width: calc((100vw - 32px) / 4);
								text-align: center;
								height: 60px;
								line-height: 60px;
								background-color: #f5f5f5;
								color: #4f4f4f;
								border-radius: 40px;
								border-color: #f5f5f5;
							}

							.van-icon::before {
								display: none;
							}
						}
					}


				}

				.yangshi1 {
					height: 70px;
					overflow: hidden;
				}

				.yangshi2 {
					height: 100%;
				}

				.seleHeight {
					height: 100%;
				}

				.seleImg {
					width: 100px;
					height: 60px;
					position: relative;
					img {
						width: 30px;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%,-50%);
					}
				}
			}
		}

		.foot_box {
			height: 110px;
			width: 100%;
			background-color: #fff;
			position: fixed;
			bottom: 0px;
		}

		.position_footer {
			padding: 0 16px;
			width: calc(100vw - 32px);
			overflow: hidden;
			position: absolute;
			bottom: 20px;
		}
	}
</style>
<style>
	.van-search {
		background-color: transparent;
	}

	.van-search__content {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		padding-left: 8px;
		border: 1px solid #e5e5e5;
		/*no*/
		color: #7f7f7f;
		background-color: #fff;
		border-radius: 20px;
		/*no*/
	}

	.van-field__body input[type="search"]::placeholder {
		font-size: 32px;
		/*px*/
	}

  .bx_color{
      color: #fff;
      background-color: #ff4081;
  }
</style>
